/**
 * Shows the selected option SKU inline for APO choice tiles and custom selects.
 * SKU is read from Mageworx's [data-mw-option-accumulated-title].
 */
(function () {
  'use strict';

  const DEBOUNCE_MS = 50;
  let debounceTimer;

  const BOX_OPTION_SELECTOR =
    '.mw-option--type-choicetile, .mw-option--type-multichoicetile';
  const SELECT_OPTION_SELECTOR = '.mw-option--type-select';

  function queryApoRoots() {
    const roots = new Set();
    document.querySelectorAll('#mw-apo-app-block, .mw-apo-container').forEach(function (el) {
      roots.add(el);
    });
    return roots;
  }

  function extractSkuFromAccumulatedTitle(el) {
    if (!el) return '';
    var spans = el.querySelectorAll('.mw-text');
    for (var i = 0; i < spans.length; i++) {
      var text = (spans[i].textContent || '').trim();
      if (/^SKU:\s*/i.test(text)) {
        return text.replace(/^SKU:\s*/i, '').trim();
      }
    }
    var match = (el.textContent || '').match(/SKU:\s*(\S+)/i);
    return match ? match[1].trim() : '';
  }

  function getOptionSku(optionEl) {
    return extractSkuFromAccumulatedTitle(
      optionEl.querySelector('[data-mw-option-accumulated-title]')
    );
  }

  function removeInlineSkus(root) {
    root.querySelectorAll('.mw-apo-value-sku').forEach(function (el) {
      el.remove();
    });
  }

  function appendBoxSku(titleEl, sku) {
    if (!titleEl || !sku) return;
    var skuEl = document.createElement('div');
    skuEl.className = 'mw-apo-value-sku mw-apo-value-sku--box';
    skuEl.textContent = sku;
    titleEl.appendChild(skuEl);
  }

  function appendSelectSku(afterEl, sku) {
    if (!afterEl || !sku) return;
    var skuEl = document.createElement('span');
    skuEl.className = 'mw-apo-value-sku';
    skuEl.textContent = ' ' + sku;
    afterEl.insertAdjacentElement('afterend', skuEl);
  }

  function getCardTitleEl(valueRow) {
    var wrapper = valueRow.querySelector('.mw-stack--card__pricetitle-wrapper');
    if (!wrapper) return null;
    var titles = wrapper.querySelectorAll('.mw-stack--card__title');
    return titles.length ? titles[titles.length - 1] : null;
  }

  function valueRowIsSelected(row) {
    if (row.classList.contains('mw-option__value--selected')) return true;
    var input = row.querySelector('input.mw-option__control');
    return !!(input && input.checked);
  }

  function syncBoxOptionSkus(optionEl) {
    removeInlineSkus(optionEl);
    var sku = getOptionSku(optionEl);
    if (!sku) return;

    optionEl.querySelectorAll('.mw-option__value').forEach(function (row) {
      if (!valueRowIsSelected(row)) return;
      var titleEl = getCardTitleEl(row);
      if (titleEl) appendBoxSku(titleEl, sku);
    });
  }

  function syncSelectOptionSkus(optionEl) {
    removeInlineSkus(optionEl);
    var sku = getOptionSku(optionEl);
    if (!sku) return;

    var valueText = optionEl.querySelector('.selectCustom-trigger .mw-option__value-text');
    if (valueText) appendSelectSku(valueText, sku);
  }

  function syncOption(optionEl) {
    if (optionEl.matches(BOX_OPTION_SELECTOR)) {
      syncBoxOptionSkus(optionEl);
      return;
    }
    if (optionEl.matches(SELECT_OPTION_SELECTOR)) {
      syncSelectOptionSkus(optionEl);
    }
  }

  function syncContainer(container) {
    if (!container || !container.querySelectorAll) return;
    container
      .querySelectorAll(BOX_OPTION_SELECTOR + ', ' + SELECT_OPTION_SELECTOR)
      .forEach(syncOption);
  }

  function syncAll() {
    queryApoRoots().forEach(syncContainer);
  }

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncAll, DEBOUNCE_MS);
  }

  function observeAccumulatedTitles(root) {
    root.querySelectorAll('[data-mw-option-accumulated-title]').forEach(function (el) {
      if (el.dataset.mwApoValueSkuObserved) return;
      el.dataset.mwApoValueSkuObserved = '1';
      var obs = new MutationObserver(scheduleSync);
      obs.observe(el, {
        subtree: true,
        childList: true,
        characterData: true,
      });
    });
  }

  function bindRoot(root) {
    if (root.dataset.mwApoValueSkuBound) return;
    root.dataset.mwApoValueSkuBound = '1';
    root.addEventListener('change', scheduleSync, true);
    root.addEventListener('input', scheduleSync, true);
    root.addEventListener('click', scheduleSync, true);
  }

  function observeRoots() {
    queryApoRoots().forEach(function (root) {
      bindRoot(root);
      observeAccumulatedTitles(root);
      if (root.dataset.mwApoValueSkuObserved) return;
      root.dataset.mwApoValueSkuObserved = '1';
      var obs = new MutationObserver(scheduleSync);
      obs.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'checked'],
      });
    });
  }

  function init() {
    syncAll();
    observeRoots();
  }

  function boot() {
    init();
    setTimeout(init, 400);
    setTimeout(init, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('mw-apo:auto-select', scheduleSync);
})();
